import { render, staticRenderFns } from "./CalculatingGramsProduced.vue?vue&type=template&id=60917a6c&scoped=true&"
import script from "./CalculatingGramsProduced.vue?vue&type=script&lang=js&"
export * from "./CalculatingGramsProduced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60917a6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
